import type { JSX } from "react";
import { Suspense, useMemo } from "react";
import { Text3D } from "@react-three/drei";
import * as THREE from "three";
import { useSceneStore } from "@/state/useSceneStore";

const DARK_FRONT = "#0b0d10";
const DARK_SIDE = "#1f2227";
const LIGHT_FRONT = "#1a1d23";
const LIGHT_SIDE = "#a8b0b8";

const Inner = (): JSX.Element => {
  const theme = useSceneStore((s) => s.theme);

  const materials = useMemo(() => {
    const front = theme === "dark" ? DARK_FRONT : LIGHT_FRONT;
    const side = theme === "dark" ? DARK_SIDE : LIGHT_SIDE;
    return [
      new THREE.MeshStandardMaterial({ color: side, flatShading: true }),
      new THREE.MeshStandardMaterial({
        color: front,
        roughness: 0.5,
      }),
    ];
  }, [theme]);

  return (
    <>
      <Text3D
        font="/fonts/lora.json"
        size={0.08}
        height={0.01}
        curveSegments={6}
        bevelEnabled={false}
        position={[-0.27, 0.55, 0.5]}
        rotation={[0, Math.PI / 2, 0]}
        material={materials}
      >
        Adam Kotlorz
      </Text3D>
      <Text3D
        font="/fonts/lora.json"
        size={0.022}
        height={0.003}
        curveSegments={6}
        bevelEnabled={false}
        position={[-0.255, 0.5, 0.5]}
        rotation={[0, Math.PI / 2, 0]}
        material={materials}
      >
        Web Developer / ML/AI Engineer / Mobile App Developer
      </Text3D>
    </>
  );
};

export const WallTitle = (): JSX.Element => (
  <Suspense fallback={null}>
    <Inner />
  </Suspense>
);
